import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import ModalDropdown from '../../component/ModalDropdown';
import Exported from '../../service/endpoints';
import request from '../../service';
import { useNavigate } from 'react-router-dom';

const NotificationDropdown = (props) => {
    const { isOpen = false, closePopUp, notifymodal = false } = props

    const [notificationList, setNotificationList] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {
        getNotificationList()
    }, [])

    const getNotificationList = async () => {
        setisLoading(true)
        let url = Exported.Endpoints.getAdminNotification
        let paramsObj = {
            page: 1,
            limit: 10,
        }

        await request({
            url: url,
            method: Exported.APIMethods.GET,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                console.log(res)
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta
                }
                if(!(obj?.result?.length > 0)) {
                    setTimeout(() => {
                        closePopUp()
                    }, 3000)
                }
                setNotificationList(obj?.result)
                setisLoading(false)
            }
        }).catch((err) => {
            console.log(err)
        })
        setisLoading(false)
    }

    const redirectToNotification = () => {
        navigate('/admin/notification')
    }

    return (
        <>
            <div className='relative' />
            <ModalDropdown isOpen={isOpen} closePopUp={closePopUp} notifymodal={notifymodal}>
                <div className={`${classes.notifyModalWrapper}`}>
                    {notificationList?.length > 0 ?
                        <>
                            <div className={`${classes.notifyModalTitle}`}>{`Notifications (${notificationList?.filter((x) => !x?.is_read)?.length})`}</div>
                            <div className={`${classes.notifyListWrapper}`}>
                                {notificationList?.map((data, idx) => {
                                    return (
                                        <div key={data?.title} className={`${classes.notificationCard} ${!data?.is_read ? classes.activeAlert : ''}`}>
                                            <div className={`${classes.notifyTitle}`}>{data?.title}</div>
                                            <div className={`${classes.notifyTimeStamp}`}>{data?.body}</div>
                                        </div>
                                    )
                                })}

                            </div>
                            <div className={`${classes.viewAllNotification}`} onClick={() => redirectToNotification()}>View all notifications</div>
                        </>
                        :
                        <p className="h-[100%] w-[100%] fs-20 py-4 flex items-center justify-center">
                            No new notifications found !!!
                        </p>
                    }
                </div>
            </ModalDropdown>
        </>
    );
}

export default NotificationDropdown